import Phaser from "phaser";
import TitleScene from "./scenes/TitleScene";
import NovelScene from "./scenes/NovelScene";
import EndScene from "./scenes/EndScene";

export function initPhaserGame() {
  const config = {
    type: Phaser.AUTO,
    parent: "game-container",
    width: 800,
    height: 600,
    backgroundColor: "#f7f7f7",
    physics: { default: "arcade" },
    scene: [TitleScene, NovelScene, EndScene],
    scale: {
      mode: Phaser.Scale.FIT,
      autoCenter: Phaser.Scale.CENTER_HORIZONTALLY,
    },
    banner: false,
  };

  const game = new Phaser.Game(config);
  window.__PHASER_GAME__ = game;
}
